import Step1 from './validations/Step1';
import Step4 from './validations/Step4';
import { validateStep3 } from './validations/Step3';
import { validateStep2 } from './validations/Step2';
import { validateBenefitsForm } from './validations/Step4stat';


export const validateStep = async (step, formData, isEdit) => {
  const errors = {};

  let valSt1 = {};


  if (step === 1) {
     valSt1 = await Step1(formData,  isEdit);

  }

  if(step === 2) {
    Object.assign(errors, await validateStep2(formData, isEdit));
  }

  if(step === 4) {
    Object.assign(errors, await Step4(formData),  await validateBenefitsForm(formData) );
  }


  if(step === 3) {
     Object.assign(errors, await validateStep3(formData, isEdit));
  }

  if (step === 21) {
    if (!formData.applicant.lastName) errors.applicantLastName = 'Прізвище обов\'язкове';
    if (!formData.applicant.firstName) errors.applicantFirstName = 'Ім\'я обов\'язкове';
    if (!formData.applicant.rnokpp) errors.applicantRnokpp = 'РНОКПП обов\'язковий';
    if (!formData.applicant.phone) errors.applicantPhone = 'Телефон обов\'язковий';
    else if(!/\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}$/.test(formData.applicant.phone)) {
        errors.applicantPhone = 'Невірний формат телефону';
    }
    if (!formData.applicant.email) errors.applicantEmail = 'Email обов\'язковий';
    else if (!/^\S+@\S+\.\S+$/.test(formData.applicant.email)) {
      errors.applicantEmail = 'Невірний формат email';
    }
    if (!formData.applicant.address) errors.applicantAddress = 'Адреса обов\'язкова';
  }

  if (step === 6) {
    if (formData.agreePersonalData == "no") errors.agreePersonalData = 'Необхідно погодитись на обробку даних';
  }


  return Object.assign({},errors, valSt1);
};